import "core-js/modules/es6.array.slice";
import "core-js/modules/es6.function.bind";
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

export default function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}